import { styled } from 'parkdepot-shared/theme'

export const DiscountRow = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    color: $theme.colors.positive700,
    width: '100%'
}))

export const DiscountRowText = styled('p', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphSmall
}))
